"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Espool = void 0;
const echain_shared_i18n_1 = require("@igus/echain-shared-i18n");
const echain_shared_quantities_1 = require("@igus/echain-shared-quantities");
const Article_1 = require("../Article");
const echain_product_models_1 = require("@igus/echain-product-models");
const echain_shared_oo_1 = require("@igus/echain-shared-oo");
class Espool extends Article_1.Article {
    constructor() {
        super(...arguments);
        this.className = 'Espool';
    }
    get biegeradiusMin() {
        return echain_shared_quantities_1.Q.optional(this.model.BiegeradiusMin);
    }
    set biegeradiusMin(value) {
        this.model.BiegeradiusMin = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get leftKette() {
        return this.model.LeftKette;
    }
    set leftKette(value) {
        this.model.LeftKette = value;
    }
    get leitungDiameterMax() {
        return echain_shared_quantities_1.Q.optional(this.model.LeitungDiameterMax);
    }
    set leitungDiameterMax(value) {
        this.model.LeitungDiameterMax = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get leitungLengthMin() {
        return echain_shared_quantities_1.Q.optional(this.model.LeitungLengthMin);
    }
    set leitungLengthMin(value) {
        this.model.LeitungLengthMin = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get linearExtension() {
        return this.model.LinearExtension;
    }
    set linearExtension(value) {
        this.model.LinearExtension = value;
    }
    get linearKette() {
        return this.model.LinearKette;
    }
    set linearKette(value) {
        this.model.LinearKette = value;
    }
    get rightKette() {
        return this.model.RightKette;
    }
    set rightKette(value) {
        this.model.RightKette = value;
    }
    get serieKuerzel() {
        return this.model.SerieKuerzel;
    }
    set serieKuerzel(value) {
        this.model.SerieKuerzel = value;
    }
    get totalWeight() {
        return echain_shared_quantities_1.Q.optional(this.model.TotalWeight);
    }
    set totalWeight(value) {
        this.model.TotalWeight = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get trommelDiameter() {
        return echain_shared_quantities_1.Q.optional(this.model.TrommelDiameter);
    }
    set trommelDiameter(value) {
        this.model.TrommelDiameter = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get extraLeitungLength() {
        return (0, echain_shared_quantities_1.Q)(this.model.ExtraLeitungLength);
    }
    set extraLeitungLength(value) {
        this.model.ExtraLeitungLength = value.quantity;
    }
    static fromScratch() {
        return new Espool({
            ArticleType: echain_product_models_1.ArticleType.espool,
            EntityId: echain_shared_oo_1.UUIDGenerator.new(),
            ExtraLeitungLength: { Value: 0, Unit: 'mm' },
        });
    }
    static fromJson(json, cloneStrategy = 'deep') {
        const espool = Espool.fromScratch();
        espool.fromJson(json, cloneStrategy);
        return espool;
    }
    static fromModel(model) {
        const espool = Espool.fromScratch();
        Object.assign(espool.model, model);
        Object.assign(model, espool.model);
        espool.model = model;
        return espool;
    }
    clone() {
        return this._clone(Espool.fromScratch());
    }
    duplicate() {
        return this._duplicate();
    }
    getEspoolIaArtNrs(includesZugentlastung = false) {
        var _a, _b, _c, _d, _e;
        return {
            left: ((_a = this.leftKette) === null || _a === void 0 ? void 0 : _a.IaRefs) || [],
            center: includesZugentlastung
                ? [...(((_b = this.linearKette) === null || _b === void 0 ? void 0 : _b.IaRefs) || []), ...(((_c = this.linearKette) === null || _c === void 0 ? void 0 : _c.StrainReliefSeparatorRefs) || [])]
                : ((_d = this.linearKette) === null || _d === void 0 ? void 0 : _d.IaRefs) || [],
            right: ((_e = this.rightKette) === null || _e === void 0 ? void 0 : _e.IaRefs) || [],
        };
    }
    getAllEspoolIaArtNrs(includesZugentlastung = false) {
        const getEspoolIaArtNrs = this.getEspoolIaArtNrs(includesZugentlastung);
        return [...getEspoolIaArtNrs.left, ...getEspoolIaArtNrs.center, ...getEspoolIaArtNrs.right];
    }
    getChildArtNrs() {
        var _a, _b, _c;
        return Array.from(new Set([(_a = this.linearKette) === null || _a === void 0 ? void 0 : _a.Ref, (_b = this.leftKette) === null || _b === void 0 ? void 0 : _b.Ref, (_c = this.rightKette) === null || _c === void 0 ? void 0 : _c.Ref])).filter((el) => !!el);
    }
    getLocalizedSerieKuerzel() {
        var _a, _b, _c, _d;
        if (echain_shared_i18n_1.LocaleService.getArtNrCountry() === 'US') {
            return ((_a = this.model.SerieKuerzel) === null || _a === void 0 ? void 0 : _a.Imperial) || ((_b = this.model.SerieKuerzel) === null || _b === void 0 ? void 0 : _b.Metric);
        }
        return ((_c = this.model.SerieKuerzel) === null || _c === void 0 ? void 0 : _c.Metric) || ((_d = this.model.SerieKuerzel) === null || _d === void 0 ? void 0 : _d.Imperial);
    }
    /**
     * checks if given Leitungen fit in espool
     * result contains for each leitung artNr and the result for the check of aussendurchmesser, biegeradius, leitungslaenge
     */
    canLeitungenLayIn(leitungen) {
        return leitungen.map((leitung) => {
            const result = {
                aussendurchmesserCheck: true,
                biegeradiusCheck: true,
                leitungsLaengeCheck: true,
            };
            if (leitung.aussendurchmesser && this.leitungDiameterMax) {
                result.aussendurchmesserCheck = leitung.aussendurchmesser.mm <= this.leitungDiameterMax.mm;
            }
            if (leitung.biegeradiusMin && this.biegeradiusMin) {
                result.biegeradiusCheck = leitung.biegeradiusMin.mm <= this.biegeradiusMin.mm;
            }
            if (leitung.leitungslaenge && this.leitungLengthMin) {
                result.leitungsLaengeCheck = leitung.leitungslaenge.mm >= this.leitungLengthMin.mm;
            }
            return result;
        });
    }
}
exports.Espool = Espool;
//# sourceMappingURL=Espool.js.map